export default "__VITE_ASSET__B0Nc4HWZ__"